import React, { Fragment } from 'react'
import styled from 'styled-components'

import { themeEstra } from 'src/styles/themeEstra'
import { Button } from '../Button'
import closeIcon from 'static/icons/close.svg'

interface Props {
  name: string
  accept?: string
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void

  OnClearInput?: () => void
  selectedFileName?: string
}

export const InputFile: React.FC<Props> = ({
  name,
  accept,
  onChange,
  OnClearInput,
  selectedFileName,
}) => {
  return (
    <Fragment>
      <Wrapper>
        <InputWrapper>
          <Input
            id={name}
            type='file'
            name={name}
            accept={accept}
            onChange={onChange}
          />
          <File>{selectedFileName}</File>
          {selectedFileName && OnClearInput && (
            <ClearButton variant='trasparente' onClick={OnClearInput}>
              <img src={closeIcon} alt='close' width={'10'} height={'10'}></img>
            </ClearButton>
          )}
        </InputWrapper>
        <InputLabel htmlFor={name} />
      </Wrapper>
    </Fragment>
  )
}

const buttonWidth = '65px'
const clearButtonWidth = '40px'
const inputHeight = '40px'

const Wrapper = styled.div`
  position: relative;
  font-size: 0.75rem; /*14px*/
`

const InputWrapper = styled.div`
  position: relative;
  text-align: left;
`

const File = styled.div`
  position: absolute;
  display: block;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 5;
  left: 1.5rem;
  line-height: 38px;
  pointer-events: none;
  touch-action: none;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  padding-right: calc(${buttonWidth} + ${clearButtonWidth});
`

const ClearButton = styled(Button)`
  position: absolute;
  display: block;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 5;
  padding: 0rem 1rem;
  right: ${buttonWidth};
  height: ${inputHeight};
  width: ${clearButtonWidth};
`

const Input = styled.input`
  position: relative;
  z-index: 2;
  width: 0;
  height: ${inputHeight};
  margin: 0;
  opacity: 0;

  &:hover + label {
    opacity: 0.8;
  }
`

const InputLabel = styled.label`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
  height: 38px;
  height: calc(${inputHeight} - 2px); //Account for border
  line-height: calc(${inputHeight} - 2px);

  background: white;
  border: 1px solid ${themeEstra.color.neutri.grigioChiaro};
  border-radius: 10rem;
  outline: none;
  cursor: pointer;

  &:after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 3;
    content: 'Scegli';
    /* Button Style */
    font-family: inherit;
    font-size: inherit;
    letter-spacing: 0.02em;
    text-align: center;
    padding: 0 1rem;
    border-radius: 0 10rem 10rem 0;
    width: ${buttonWidth};

    border: 0;
    cursor: pointer;
    color: ${themeEstra.color.primari.grigioEstra};
    background: ${themeEstra.color.neutri.grigioBg};
  }
`
